import { render, staticRenderFns } from "./DD.vue?vue&type=template&id=7a95b65c&"
import script from "./DD.vue?vue&type=script&lang=js&"
export * from "./DD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports